import React from 'react'
import { render } from 'react-dom'

import { ExternalModalAdapter } from '../../Common/Components/Modal/ExternalModalAdapter'
import { CommonFormContextProvider } from '../../Common/Contexts/CommonFormContext'
import { UsersByExtensionsModal } from '../Modal/UsersByExtensionModal'
import { $window } from '../../../NonReact/common/AkixiWindow'

/**
 * Adapter to create the Users By Extension modal.
 */
export default class UsersByExtensionAdapter extends ExternalModalAdapter {
    constructor() {
        super()

        $window.disableHotKeys = true

        render(
            <CommonFormContextProvider>
                <UsersByExtensionsModal />
            </CommonFormContextProvider>,
            this.modalDiv
        )
    }

    public static newInstance(): UsersByExtensionAdapter {
        return new UsersByExtensionAdapter()
    }
}
